import cx from 'classnames'
import * as React from 'react'

import type { VideoViewModel } from '../../view-models/VideoViewModel'
import { trackEvent } from '../../utils/gtag'
import type { ImageSizes } from '../../utils/image-utils'
import { aspectRatios } from '../../utils/image-utils'
import BaseButton from '../BaseButton/BaseButton'
import Image from '../Image/Image'
import MediaQuery from '../MediaQuery/MediaQuery'
import PlayButton from '../PlayButton/PlayButton'
import Youtube from '../Youtube/Youtube'
import YoutubeModal from '../YoutubeModal/YoutubeModal'
import styles from './videoPlayer-style.css'

type Props = VideoViewModel
type State = {
  isOpen: boolean
  isReady: boolean
  loadVideo: boolean
  eventIsSaved: boolean
}
const sizes: ImageSizes = {
  maxWidth: '100vw',
}

class VideoPlayer extends React.Component<Props, State> {
  static displayName = 'VideoPlayer'
  static defaultProps = {}
  state = {
    isOpen: false,
    isReady: false,
    loadVideo: false,
    eventIsSaved: false,
  }
  handleRequestClose = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    this.setState({
      isOpen: false,
    })
  }
  handleOpen = () => {
    this.setState({
      isOpen: true,
    })

    if (!this.state.eventIsSaved) {
      trackEvent({
        event: 'video-open',
      })
      this.setState({
        eventIsSaved: true,
      })
    }
  }
  handleYoutubeReady = () => {
    this.setState({
      isReady: true,
    })
  }
  handleLoadVideo = () => {
    this.setState({
      loadVideo: true,
    })
  }

  render() {
    const { videoId, placeholder, videoTitle, aspectRatio, className } = this.props
    const { loadVideo } = this.state

    if (!videoId) {
      console.warn('Please provide a video id')

      return null
    }


    return (
      <MediaQuery defaultMatches={true} query={'(min-width: 769px)'}>
        {(matches) => (
          <BaseButton
            className={styles.button}
            onClick={matches ? this.handleOpen : this.handleLoadVideo}
          >
            {({ hovering }) => (
              <div className={styles.container}>
                <div
                  className={cx(styles.video, className, hovering && styles.hovering)}
                  style={{
                    paddingBottom: aspectRatio
                      ? `calc(${aspectRatio * 100}%)`
                      : matches
                        ? `calc(${aspectRatios.desktop} * 100%)`
                        : `calc(${aspectRatios.mobile} * 100%)`,
                  }}
                >
                  <Image {...placeholder} src={placeholder?.src ?? ''} fill sizes={sizes} />


                  {matches ? (
                    <YoutubeModal
                      src={videoId}
                      isOpen={this.state.isOpen}
                      onRequestClose={this.handleRequestClose}
                    />
                  ) : (
                    loadVideo && (
                      <Youtube
                        src={videoId}
                        onReady={this.handleYoutubeReady}
                        autoPlay={this.state.isReady}
                      />
                    )
                  )}
                </div>
                <div className={cx(styles.actions, videoTitle && styles.actionsRelative)}>
                  <div className={styles.playButton}>
                    <span className={styles.playButtonText}>Afspil</span>
                    <span
                      className={styles.playIcon}><svg
                      width="10"
                      height="10"
                      fill="none"><path
                      fill="#89FFC5"
                      fillRule="evenodd"
                      d="M2.13 10.002c-.256 0-.514-.055-.755-.168C.835 9.579.5 9.074.5 8.512V1.491C.5.93.835.424 1.375.169a1.738 1.738 0 0 1 1.84.216l4.25 3.511c.34.28.535.684.535 1.105 0 .422-.194.825-.535 1.105l-4.25 3.511a1.7 1.7 0 0 1-1.085.385Z"
                      clipRule="evenodd" /></svg>
                    </span>
                  </div>
                  <p className={styles.titleText}>{videoTitle}</p>
                </div>
              </div>
            )}
          </BaseButton>
        )}
      </MediaQuery>
    )
  }
}

export default VideoPlayer
